module.exports = __webpack_public_path__ + "static/media/identify_attract_top_talent.280fa71e.svg";